<div [@fadeIn]="'state'" class="container background">

  <div [class]="'container-message ' + type">
    <span [class]="'container-message-hint-' +type">
      @if (type === 'warning') {
        <mat-icon class="message-icon">report_problem</mat-icon>
      }
      @if (type === 'success') {
        <mat-icon class="message-icon">check_circle_outline</mat-icon>
      }
      @if (type === 'info') {
        <mat-icon class="message-icon">info</mat-icon>
      }
      @if (type === 'error') {
        <mat-icon class="message-icon">highlight_off</mat-icon>
      }
    </span>{{ message }}

    <div class="container-close-icon">
      <button mat-icon-button (click)="close()">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>

  </div>

</div>
